import React from "react";
import Link from "next/link";
import {
  buttonStyles,
  BUTTON_ACCENTS,
  BUTTON_VARIANTS,
} from "./simpleButton";
import type { ButtonAccent, ButtonVisualVariant } from "./simpleButton";

export type { ButtonAccent, ButtonVisualVariant };
export { BUTTON_ACCENTS, BUTTON_VARIANTS };

export type LinkButtonProps = {
  children: React.ReactNode;
  href: string;
  target?: string;
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  accent?: ButtonAccent;
  variant?: ButtonVisualVariant;
  size?: "sm" | "md" | "lg";
  className?: string;
  "data-testid"?: string;
  "aria-label"?: string;
};

/**
 * A button-styled Next.js Link component.
 * Shares visual styles with SimpleButton but renders as an anchor element.
 * Use this instead of wrapping SimpleButton in a Link to avoid invalid
 * <a><button> nesting.
 */
export const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  href,
  target,
  rel,
  onClick,
  accent,
  variant,
  size,
  className,
  "data-testid": dataTestId,
  "aria-label": ariaLabel,
}) => {
  return (
    <Link
      href={href}
      target={target}
      rel={rel}
      onClick={onClick}
      aria-label={ariaLabel}
      className={buttonStyles({ variant, accent, size, className })}
      data-testid={dataTestId}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
